import { useEffect, useState } from "react";

export const DiagnosisName = (props) => {
  const { filter, onChange, onSubmit } = props;

  const opt = [
    { value: "current_care_diagnosis_name__contains", label: "Obsahuje" },
    { value: "current_care_diagnosis_name__startswith", label: "Začíná na" },
    { value: "current_care_diagnosis_name__endswith", label: "Končí na" },
  ];

  const [option, setOption] = useState({
    value: "current_care_diagnosis_name__contains",
    label: "Obsahuje",
  });
  const [value, setValue] = useState();
  const [options, setOptions] = useState(opt);

  useEffect(() => {
    if (filter.current_care_diagnosis_name__startswith) {
      setValue(filter.current_care_diagnosis_name__startswith);
      setOption(
        opt.find(
          (item) => item.value === "current_care_diagnosis_name__startswith"
        )
      );
    } else if (filter.current_care_diagnosis_name__endswith) {
      setValue(filter.current_care_diagnosis_name__endswith);
      setOption(
        opt.find(
          (item) => item.value === "current_care_diagnosis_name__endswith"
        )
      );
    } else if (filter.current_care_diagnosis_name__contains) {
      setValue(filter.current_care_diagnosis_name__contains);
      setOption(
        opt.find(
          (item) => item.value === "current_care_diagnosis_name__contains"
        )
      );
    } else {
      setValue("");
      setOption(option);
    }
  }, [filter]);

  useEffect(() => {
    if (filter.current_care_diagnosis_name__startswith) {
      setOption(
        opt.find(
          (item) => item.value === "current_care_diagnosis_name__startswith"
        )
      );
    } else if (filter.current_care_diagnosis_name__endswith) {
      setOption(
        opt.find(
          (item) => item.value === "current_care_diagnosis_name__endswith"
        )
      );
    } else if (filter.current_care_diagnosis_name__contains) {
      setOption(
        opt.find(
          (item) => item.value === "current_care_diagnosis_name__contains"
        )
      );
    } else {
      setOption(option);
    }
  }, []);

  const handleChange = (event) => {
    const option = options.find((item) => item.value === event.target.value);
    setOption(option);
    const oldEvent = {
      target: { value: value ? value : "", name: option.value },
    };
    onChange(oldEvent);
  };

  const onKeyPress = (e) => {
    // Enter
    if (e.which === 13) {
      onSubmit();
    }
  };

  return (
    <td role="cell" className="td-filter">
      <select
        className="table-filter-select"
        name="select"
        onChange={handleChange}
      >
        <option value={option.value}>{option.label}</option>
        {options.map((item, key) => (
          <option
            className={item.value === option.value ? "hidden" : ""}
            key={key}
            value={item.value}
          >
            {item.label}
          </option>
        ))}
      </select>
      <input
        type="text"
        name={option.value}
        className="table-filter-input"
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
      />
    </td>
  );
};
